// Individual role definitions
export const OWNER_ROLE = 'Owner' as const;
export const MANAGER_ROLE = 'Manager' as const;
export const STAFF_ROLE = 'Staff' as const;
export const RECEPTIONIST_ROLE = 'Receptionist' as const;

// Page access roles
export const EMPLOYEE_PAGE_ROLES = [OWNER_ROLE] as const;
export const SCHEDULE_PAGE_ROLES = [OWNER_ROLE, MANAGER_ROLE, STAFF_ROLE] as const;
export const SETTINGS_PAGE_ROLES = [OWNER_ROLE] as const;

// Role groups by access level
export const AUTHORIZED_ROLES = [OWNER_ROLE] as const;
export const MANAGEMENT_ROLES = [OWNER_ROLE, MANAGER_ROLE] as const;
export const STAFF_ROLES = [OWNER_ROLE, MANAGER_ROLE, STAFF_ROLE] as const;
export const ALL_ROLES = [OWNER_ROLE, MANAGER_ROLE, STAFF_ROLE, RECEPTIONIST_ROLE] as const;

// Type definitions
export type Role = (typeof ALL_ROLES)[number];
export type AuthorizedRole = (typeof AUTHORIZED_ROLES)[number];
export type ManagementRole = (typeof MANAGEMENT_ROLES)[number];
export type StaffRole = (typeof STAFF_ROLES)[number];
export type EmployeePageRole = (typeof EMPLOYEE_PAGE_ROLES)[number];
